module.exports = __webpack_public_path__ + "my.cd942bda.svg";